'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interpolateToJsx = exports.interpolate = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _verify = require('helpers/verify');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VARIABLE_REGEX = /(\$[a-zA-Z]\w*)/;

function interpolateToArray(text) {
  var replacementByVariable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if ((0, _verify.isBlank)(text)) {
    return [];
  }

  /* eslint-disable no-nested-ternary */
  return text.split(VARIABLE_REGEX).map(function (segment) {
    return !(VARIABLE_REGEX.test(segment) && segment in replacementByVariable) ? segment : (0, _verify.isPresent)(replacementByVariable[segment]) ? replacementByVariable[segment] : '';
  });
  /* eslint-enable no-nested-ternary */
}

var interpolate = exports.interpolate = function interpolate() {
  return interpolateToArray.apply(undefined, arguments).join('');
};

var interpolateToJsx = exports.interpolateToJsx = function interpolateToJsx() {
  return interpolateToArray.apply(undefined, arguments)
  // eslint-disable-next-line react/no-array-index-key
  .map(function (bit, idx) {
    return _react2.default.createElement(
      _react.Fragment,
      { key: bit + '_' + idx },
      bit
    );
  });
};